import { useTranslation } from 'react-i18next'

import { DotsThreeCircleVertical } from '@phosphor-icons/react'

import { ButtonMenu, ChatAlertIcon, IconButton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ClaimsCardMenu = ({ onOpenClaim, allowOpenClaim }) => {
  const { t } = useTranslation()
  const options = [
    {
      label: (
        <Styles.MenuOptionLabel>
          <ChatAlertIcon size="16" />
          {t('Abrir una incidencia')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onOpenClaim,
      disabled: false,
      visible: allowOpenClaim,
    },
  ]

  if (!options.some(option => option.visible)) {
    return null
  }

  return (
    <ButtonMenu
      menuItems={options.filter(option => option.visible)}
      renderButton={onOpen => (
        <IconButton
          onClick={onOpen}
          variant="text"
          icon={<DotsThreeCircleVertical data-testid="claimsCardMenuButton" size={24} />}
        />
      )}
    />
  )
}

export default ClaimsCardMenu
